export default __webpack_public_path__ + "static/media/DSS_certified.839ae29b.svg";